export default __webpack_public_path__ + "static/media/sustainingwrath.fbd019a9.png";